import styles from "../onboard.module.css";
import { Col, Row } from "react-bootstrap";
import SignInInput from "../../../common/SigninInput/signinInput";
import DateInputWithCalendar from "../../../common/DateCalender/DateCalender";
import CommonButton from "../../CommonButton/CommonButton";
import Dropdown from "../../Dropdown/dropdown";
import { relationOptions } from "../../../constant";

function Studentform({
  placeOfIssueError,
  placeOfIssue,
  mcaPullStudentData,
  remitterTypeDisabled,
  remitterTypeError,
  relationError,
  setRemitterType,
  setRelation,
  remitterType,
  name,
  handleChange,
  email,
  valid,
  handleBlur,
  emailError,
  phoneNumber,
  phoneNoError,
  postalCode,
  postalError,
  address,
  city,
  state,
  dob,
  onHandleDate,
  dobError,
  passExpiryError,
  passIssueError,
  passportError,
  passportExpiryDate,
  passportIssueDate,
  passportNo,
  passportname,
  nextSectionError,
  checkIfValid,
  handleClearAll,
  loading,
  themeColor,
  isFormDisabled = false,
}) {
  return (
    <div>
      <Row>
        <Col md={4}>
          <SignInInput
            name="name"
            label="Full Name"
            placeholder="Enter Full Name"
            type="text"
            value={name}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            isInvalid={valid.name}
            disabled={isFormDisabled && mcaPullStudentData?.full}
          />
        </Col>
        <Col md={4}>
          <SignInInput
            name="email"
            label="Email ID"
            placeholder="Enter Email ID"
            type="text"
            value={email}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            isInvalid={valid.email}
            onBlur={(event) => {
              handleBlur(event);
            }}
            errorMessage={emailError}
            disabled={isFormDisabled && mcaPullStudentData?.emailId}
          />
        </Col>
        <Col md={4}>
          <SignInInput
            name="phoneNumber"
            label="Phone Number"
            placeholder="Enter Phone Number"
            type="tel"
            value={phoneNumber}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            isInvalid={valid.phoneNumber}
            onBlur={(event) => {
              handleBlur(event);
            }}
            errorMessage={phoneNoError}
            showcodediv={true}
            codedivName={"phone"}
            disabled={isFormDisabled && mcaPullStudentData?.phoneNumber}
          />
        </Col>
      </Row>
      <Row className="pt-2">
        <Col md={4}>
          <SignInInput
            name="Postal"
            label="Postal Code"
            placeholder="Enter Postal Code"
            type="number"
            value={postalCode}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            onBlur={(event) => {
              handleBlur(event);
            }}
            isInvalid={valid.postalCode}
            errorMessage={postalError}
            disabled={isFormDisabled && mcaPullStudentData?.postalCode}
          />
        </Col>
        <Col md={4}>
          <SignInInput
            name="Address"
            label="Address"
            placeholder="Enter Full Address"
            type="text"
            value={address}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            isInvalid={valid.address}
            disabled={isFormDisabled && mcaPullStudentData?.address}
          />
        </Col>
        <Col md={4}>
          <SignInInput
            name="City"
            label="City"
            placeholder="Enter City"
            type="text"
            value={city}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            isInvalid={valid.city}
            disabled={isFormDisabled && mcaPullStudentData?.city}
          />
        </Col>
      </Row>
      <Row className="pt-2">
        <Col md={4}>
          <SignInInput
            name="State"
            label="State"
            placeholder="Enter State"
            type="text"
            value={state}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            isInvalid={valid.state}
            disabled={isFormDisabled && mcaPullStudentData?.state}
          />
        </Col>
        <Col md={4}>
          <SignInInput
            name="Country"
            label="Country"
            placeholder="Enter Country"
            type="text"
            value={"India"}
            disabled={true}
          />
        </Col>
        <DateInputWithCalendar
          label="DOB"
          placeholder="Enter DOB"
          name="dateofBirth"
          value={dob}
          onHandleDate={(date) => onHandleDate(date, "dateofBirth")}
          errorMessage={dobError}
          disabled={isFormDisabled && mcaPullStudentData?.dob}
        />
      </Row>
      <Row className="pt-2">
        <Col md={4}>
          <SignInInput
            name="passportName"
            label="Passport Name"
            placeholder="Enter Passport Name"
            type="text"
            value={passportname}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            isInvalid={valid.passportname}
            disabled={isFormDisabled && mcaPullStudentData?.passportName}
          />
        </Col>
        <Col md={4}>
          <SignInInput
            name="passportNo"
            label="Passport Number"
            placeholder="Enter Passport Number"
            type="text"
            value={passportNo}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            onBlur={(event) => {
              handleBlur(event);
            }}
            errorMessage={passportError}
            isInvalid={valid.passportNo}
            disabled={isFormDisabled && mcaPullStudentData?.passportNo}
          />
        </Col>
        <Col md={4}>
          <SignInInput
            name="placeOfIssue"
            label="Place of Issue"
            placeholder="Enter Place of Issue"
            type="text"
            value={placeOfIssue}
            containerClasses={styles.passwordInvalid}
            onChange={handleChange}
            onBlur={handleBlur}
            isInvalid={valid.placeOfIssue}
            errorMessage={placeOfIssueError}
            disabled={isFormDisabled && mcaPullStudentData?.placeOfIssue}
          />
        </Col>
      </Row>
      <Row className="pt-2">
        <DateInputWithCalendar
          label="Date of Passport Issue"
          placeholder="Date of Passport Issue"
          name="passportIssueDate"
          value={passportIssueDate}
          onHandleDate={(date) => onHandleDate(date, "passportIssueDate")}
          disabled={
            (isFormDisabled && mcaPullStudentData?.passportIssueDate) ||
            dob === ""
          }
          mindate={dob}
          errorMessage={passIssueError}
        />
        <DateInputWithCalendar
          label="Date of Passport Expiry"
          placeholder="Date of Passport Expiry"
          name="passportExpiryDate"
          value={passportExpiryDate}
          onHandleDate={(date) => onHandleDate(date, "passportExpiryDate")}
          disabled={
            (isFormDisabled && mcaPullStudentData?.passportExpiryDate) ||
            dob === ""
          }
          errorMessage={passExpiryError}
        />

        {/* create two drop down  */}

        <Col md={4}>
          <SignInInput
            name="remitterType"
            label="Remitter Type"
            placeholder="Enter Remitter Type"
            type="text"
            value={remitterType}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              setRemitterType(event.target.value);
            }}
            errorMessage={remitterTypeError}
            disabled={remitterTypeDisabled}
            isInvalid={valid.remitterType}
          />
        </Col>
        {/* Show relation dropdown only when remitter type is Guardian */}
        {remitterType === "Guardian" && (
          <Col md={4}>
            <Dropdown
              options={relationOptions}
              label="Select Relation"
              heading="Relation with Student"
              onChange={(selectedValue, selectedLabel) => {
                setRelation(selectedValue);
              }}
              errorMessage={relationError}
            />
          </Col>
        )}
      </Row>
      <Row className="pt-3 mt-3 flex gap-4 ">
        <div className={styles.errorState}>{nextSectionError}</div>
        <CommonButton
          title="Next"
          onClick={checkIfValid}
          loading={loading}
          disabled={loading}
          width={"150px"}
        />
        <CommonButton
          title="Clear All"
          onClick={handleClearAll}
          disabled={loading}
          width={"150px"}
        />
      </Row>
    </div>
  );
}

export default Studentform;
